import { GenericSearchDetails } from 'app/shared/models/generic-search-details.model';
import { MessageService } from 'app/services/messages.service';
import { BadPressMatchResolution } from './../../entities/monitoring/actual/badpress-match.model';
import { SanctionMatchResolution } from 'app/entities/monitoring/actual/sanction-matches.model';
import { PEPMatchResolution } from 'app/entities/monitoring/actual/pep-match.model';
import { Injectable } from '@angular/core';

import { Organisation } from 'app/shared/models/organisation.model';
import { Person } from 'app/shared/models/person.model';

@Injectable()
export class MonitoringStatusService {
    checkOrgMonitoringStatus(organisation: Organisation) {
        const sanctionMatchResponse = this.checkSanctionStatus(organisation.sanctionStatus, false);
        return 'Attention! ' + organisation.name + ' '
            + sanctionMatchResponse
            + this.checkBadPressStatus(organisation.badPressStatus, sanctionMatchResponse !== '' ? true : false);
    }

    checkPersonMonitoringStatus(person: Person) {
        const sanctionMatchResponse = this.checkSanctionStatus(person.sanctionStatus, false);
        const pepMatchResponse = this.checkPEPStatus(person.pepStatus, sanctionMatchResponse !== '' ? true : false);
        return 'Attention! ' + person.callingName + ' '
            + sanctionMatchResponse
            + pepMatchResponse
            + this.checkBadPressStatus(person.badPressStatus, (sanctionMatchResponse !== '' || pepMatchResponse !== '') ? true : false);

    }

    checkSearchMonitoringStatus(genericSearchResult: GenericSearchDetails) {
        const sanctionMatchResponse = this.checkSanctionStatus(genericSearchResult.sanctionStatus, false);
        const pepMatchResponse = this.checkPEPStatus(genericSearchResult.pepStatus, sanctionMatchResponse !== '' ? true : false);
        const badPressMatchResponse = this.checkBadPressStatus(
            genericSearchResult.badPressStatus, (sanctionMatchResponse !== '' || pepMatchResponse !== '') ? true : false);
        return (sanctionMatchResponse === '' && pepMatchResponse === '' && badPressMatchResponse === '')
            ? '' :
            'Attention! ' + genericSearchResult.clientName + ' ' + sanctionMatchResponse + pepMatchResponse
            + badPressMatchResponse;

    }

    checkBadPressStatus(badPressStatus: BadPressMatchResolution, hasExistingMatch: boolean) {
        let response = '';
        if (badPressStatus === BadPressMatchResolution.TRUE) {
            if (hasExistingMatch) {
                response = response + ' and ';
            }
            response = response + MessageService.BAD_PRESS_MATCH.replace('%s', 'has');
        } else if (badPressStatus === BadPressMatchResolution.PROBABLE) {
            if (hasExistingMatch) {
                response = response + ' and ';
            }
            response = response + MessageService.BAD_PRESS_MATCH.replace('%s', 'might have');
        }
        return response;
    }

    checkSanctionStatus(sanctionStatus: SanctionMatchResolution, hasExistingMatch: boolean) {
        let response = '';
        if (sanctionStatus === SanctionMatchResolution.TRUE) {
            if (hasExistingMatch) {
                response = response + ' and ';
            }
            response = response + MessageService.SANCTION_MATCH.replace('%s', 'has been');
        } else if (sanctionStatus === SanctionMatchResolution.PROBABLE) {
            if (hasExistingMatch) {
                response = response + ' and  ';
            }
            response = response + MessageService.SANCTION_MATCH.replace('%s', 'is probably');
        }
        return response;
    }

    checkPEPStatus(pepStatus: PEPMatchResolution, hasExistingMatch: boolean) {
        let response = '';
        if (pepStatus === PEPMatchResolution.TRUE) {
            if (hasExistingMatch) {
                response = response + ' and ';
            }
            response = response + MessageService.PEP_MATCH.replace('%s', 'is');
        } else if (pepStatus === PEPMatchResolution.PROBABLE) {
            if (hasExistingMatch) {
                response = response + ' and ';
            }
            response = response + MessageService.PEP_MATCH.replace('%s', 'might be');
        }
        return response;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/monitoring-status.service.ts